import { Loading } from "./components/Feedback";
import { Layout } from "./components/Layout";
import { authClient } from "./lib/auth-client";
import { matchPath, useRouter } from "./lib/router";
import { ComingSoonPage } from "./pages/ComingSoonPage";
import { MockDetailPage } from "./pages/MockDetailPage";
import { MocksPage } from "./pages/MocksPage";
import { SignInPage } from "./pages/SignInPage";
import { UsersPage } from "./pages/UsersPage";
import { ciRoleCan } from "../shared/permissions";

/** Signs in, then routes to a page. */
export const App = () => {
  const { pathname } = useRouter();
  const { data: session, isPending } = authClient.useSession();

  if (isPending) {
    return <Loading />;
  }
  if (!session) {
    return <SignInPage />;
  }

  const mock = matchPath("/mocks/:tokenUuid", pathname);
  const page = mock?.tokenUuid ? (
    <MockDetailPage
      key={mock.tokenUuid}
      session={session}
      tokenUuid={mock.tokenUuid}
    />
  ) : pathname === "/users" &&
    ciRoleCan({ role: session.user.role, permissions: { user: ["list"] } }) ? (
    <UsersPage session={session} />
  ) : pathname === "/test-results" ? (
    <ComingSoonPage
      title="Test results"
      description="Cypress and Vitest runs per branch, PR and commit: failures, flaky tests (passed on retry), and spec durations over time."
      source="Reads CypressTestHistory, which every Cypress run already writes to the CI database."
    />
  ) : pathname === "/coverage" ? (
    <ComingSoonPage
      title="Coverage"
      description="Line, branch and function coverage per run and per file, with trends on develop and the change on each PR."
      source="Needs CI to upload coverage-summary.json from Vitest and the merged Cypress report."
    />
  ) : (
    <MocksPage session={session} />
  );

  return <Layout session={session}>{page}</Layout>;
};
